import './styles.css';
import { projectApi } from '../api';
import { useNavigate, useParams } from 'react-router-dom';
import ProjectPopup from './ProjectPopup';
import { Button, Flex, Input, Modal, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import TableComponent from '../other/TableComponent';
import { EditOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import { getRoles } from '@testing-library/react';
import {userRole} from '../../GetRole.utils';
import { highlightSearchText } from '../other/usefulFunctions';

const Project = () => {
  // const { totalRecordCount, page } = useParams();
  const [totalRecordCount, setTotalRecords] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allProjectData, setAllProjectData] = useState([]);
  const [filterFields, setFilterFields] = useState({
    page: 1,
    filterField: '',
    sorting: { field: '', order: '' },
    filterValue: '',
  });

  const navigate = useNavigate();

  const [clearForm, setClearForm] = useState(false);
  const [apiHit, setApiHit] = useState(false);
  const [breadcrumbActionsEl, setBreadcrumbActionsEl] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const [globalSearch, setGlobalSearch] = useState('');

  useEffect(() => {
    setBreadcrumbActionsEl(document.getElementById('breadcrumb-actions'));
  }, []);

  
  useEffect(() => {
    const timer = setTimeout(() => setGlobalSearch(searchInput.trim()), 400);
    return () => clearTimeout(timer);
  }, [searchInput]);

  const handleFilters = (value) => {
    setFilterFields((prevState) => {
      if (
        prevState.page !== value.page ||
        prevState.filterField !== value.filterField ||
        prevState.sorting.field !== value.sorting.field ||
        prevState.sorting.order !== value.sorting.order ||
        prevState.filterValue !== value.filterValue
      ) {
        return {
          page: value.page,
          filterField: value.filterField,
          sorting: {
            field: value.sorting.field,
            order: value.sorting.order,
          },
          filterValue: value.filterValue,
        };
      } else {
        return prevState;
      }
    });
  };

  const showModal = (key) => {
    setSelectedKey(key);
    setIsModalOpen(true);
    setClearForm(!clearForm);
    setApiHit(!apiHit);
  };

  const handlePopupCancel = () => {
    setSelectedKey(null);
    setIsModalOpen(false);
  };

  const getTitle = () => {
    return selectedKey ? 'Edit Engagement/Project' : 'Add Engagement/Project';
  };

  const columns = [
    {
      title: 'Project Name',
      dataIndex: 'projectName',
      key: 'projectName',
      width: '15%',
    },
    {
      title: 'Description',
      dataIndex: 'projectDescription',
      change:true,
      key: 'projectDescription',
      width: '20%',
      render: (text, record) => {
        const projectDescription = `${record.projectDescription}`;
        const shouldShowTooltip = projectDescription.length > 55;
        const truncatedprojectDescription = projectDescription.slice(0, 55);

        return (
          <div
            style={{
              maxHeight: '3em',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
            }}
          >
            {shouldShowTooltip ? (
              <Tooltip title={projectDescription}>
                <span>{highlightSearchText(truncatedprojectDescription, globalSearch)}...</span>
              </Tooltip>
            ) : (
              <>{highlightSearchText(truncatedprojectDescription, globalSearch)}</>
            )}
          </div>
        );
      },
    },
    {
      title: 'Client',
      dataIndex: 'legalEntityName',
      key: 'legalEntityName',
      width: '15%',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      width: '12%',
      fixed: 'right',
      render: (_, record) => (
        <>
          {userRole !== 'finance' && (
            <Button
              onClick={() => showModal(record?.projectId)}
              type="link"
              style={{
                color: '#003eb3',
              }}
            >
              <EditOutlined />
            </Button>
          )}
          <Modal
            title={getTitle()}
            key={isModalOpen ? 'open' : 'closed'}
            visible={isModalOpen && selectedKey === record?.projectId}
            onCancel={handlePopupCancel}
            footer={null}
          >
            <ProjectPopup
              hide={setIsModalOpen}
              isModalOpen={isModalOpen}
              buttonText={'Update'}
              clientId={record?.projectId}
              apiHit={apiHit}
            />
          </Modal>
          <Button
            type="link"
            style={{
              color: '#fa541c',
            }}
            onClick={() => navigate(`/projects/${record?.projectId}`)}
          >
            <EyeOutlined />
          </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchData();
  }, [isModalOpen, filterFields]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await projectApi.getAllProjectData(
        filterFields.page,
        filterFields.sorting.field,
        filterFields.sorting.order,
        filterFields.filterField,
        filterFields.filterValue
      );
      setAllProjectData(response.data.data);
      setTotalRecords(response.data.totalProjectCount);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 style={{ margin: 0 }}>Engagement/Project(s)</h2>

      {breadcrumbActionsEl &&
        ReactDOM.createPortal(
          <Flex align="center" gap={12} wrap="wrap">
            <Tooltip title="Search by Project Name, Description or Client">
              <Input
                allowClear
                prefix={<SearchOutlined style={{ color: '#98A2B3' }} />}
                placeholder="Search by Project Name, Description or Client"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                style={{ width: 280 }}
              />
            </Tooltip>
            {userRole !== 'finance' && (
              <Button onClick={() => showModal(null)} type="primary">
                Add Engagement/Project
              </Button>
            )}
          </Flex>,
          breadcrumbActionsEl
        )}
      <Modal
        key={isModalOpen ? 'open' : 'closed'}
        title={getTitle()}
        visible={isModalOpen && !selectedKey}
        onCancel={handlePopupCancel}
        footer={null}
      >
        <ProjectPopup
          hide={setIsModalOpen}
          isModalOpen={isModalOpen}
          buttonText={'Save'}
          clearForm={clearForm}
        />
      </Modal>

      <TableComponent
        loading={loading}
        data={allProjectData}
        columns={columns}
        scrollX={1200}
        totalPages={totalRecordCount}
        onFilters={handleFilters}
        size="small"
        disableColumnSearch
        searchField="global"
        searchValue={globalSearch}
      />
    </>
  );
};

export default Project;
